import { supabase } from '@/lib/supabase';
import type { Treatment } from '@/types/db';

export async function getTreatments(category?: Treatment['category']): Promise<Treatment[]> {
  let query = supabase.from('treatments').select('*').order('sort_order', { ascending: true });
  if (category) query = query.eq('category', category);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

export async function createTreatment(input: Partial<Treatment>): Promise<Treatment> {
  const { data, error } = await supabase.from('treatments').insert(input).select().single();
  if (error) throw error;
  return data;
}

export async function updateTreatment(id: string, patch: Partial<Treatment>): Promise<Treatment> {
  const { data, error } = await supabase.from('treatments').update(patch).eq('id', id).select().single();
  if (error) throw error;
  return data;
}

export async function deleteTreatment(id: string): Promise<void> {
  const { error } = await supabase.from('treatments').delete().eq('id', id);
  if (error) throw error;
}
